module.exports = __webpack_public_path__ + "img/redis.f11d412e.png";